// @noflow
import * as React from "react";
import Redirect from "react-router-dom/Redirect";

import { PLANT_TAGS_ACCESS } from "../lib/ManufacturingTags.generated";
import { getBackend } from "../lib/backend/Backend2";
import * as Auth from "../lib/Auth";
import local_settings, { FIELD_LAST_PLANT } from "../lib/LocalSettings";

type Props = {};
type State = {
    redirect_to: string;
};

class Home extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        const state: State = {
            redirect_to: "",
        };
        this.state = state;
    }

    async componentDidMount() {
        const plant_uuid = local_settings.getItem(FIELD_LAST_PLANT) || "";
        const { plants } = await getBackend().manufacturing.getPlants({});
        const plant = plants.find(p => p.uuid === plant_uuid);

        // is the user in pg-viewer role
        const has_elevated_priviliges = Auth.hasPermission(Auth.PERMISSION_NAMES.ElevatedPriviliges);
        // is the user in pg-viewer role
        const is_pg_viewer = Auth.isInRole(Auth.ROLE_MAN_PG_VIEWER);
        // is the user in dt-viewer role
        const is_dt_viewer = Auth.isInRole(Auth.ROLE_MAN_DT_VIEWER);

        let redirect_to = "/manufacturing/lines";
        if (is_dt_viewer && !is_pg_viewer && !has_elevated_priviliges) {
            redirect_to = "/digital-twin/";
        }

        if (plant !== undefined && PLANT_TAGS_ACCESS.new_feature_home_button(plant.tags)) {
            redirect_to = "/manufacturing/home";
        }

        this.setState({ redirect_to });
    }

    render() {
        if (this.state.redirect_to === "") {
            return null;
        }

        return <Redirect to={this.state.redirect_to} />;
    }
}

export default Home;
